<template>
  <v-layout v-if="value">
    <v-card min-height="800px" class="border-card">
      <v-toolbar color="primary" height="45" dense dark>
        <v-spacer />
        <span class="mdlHeadForms">{{ $store.state.jsIdioma.oEquivalencias.ttlNuevaActaReunionPQR}}</span>
        <v-spacer />
        <v-btn color="btncolor-dark" @click="CloseDialog()" icon small dark outlined>
          <v-icon size="14px">fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
        <span >
          <h3 class="text-medium font-normal">
            <v-icon>mdi-calendar-month-outline</v-icon> {{ $store.state.jsIdioma.oEquivalencias.cmpFechaRegistro}}:
            {{ HoraRegistro }}
          </h3>
        </span>
      </v-toolbar>
      <v-container :key="KeyRefresh">
        <v-row class="pt-3">
          <v-col sm="6" cols="6" class="py-0 ma-0 ColumnaResumida">
            <FormSelect
              v-model="nCliente"
              :titulo="$store.state.jsIdioma.oEquivalencias.cmpNombreCliente"
              :inner="'Clientes,'"
              :campo="'nombre'"
              :obligatorio="true"
              :editable="'1'"
            />
          </v-col>
          <v-col sm="6" cols="6" class="py-0 ma-0 ColumnaResumida">
            <FormSelect
              v-model="nProducto"
              :titulo="$store.state.jsIdioma.oEquivalencias.cmpProducto"
              :inner="'BC_Productos,BC_Productos.idBC_Productos=PQR_Requerimientos.idBC_Productos'"
              :campo="'Producto'"
              :obligatorio="true"
              :campoFiltro="'idClientes'"
              :valorFiltro="nCliente"
              :editable="'1'"
            />
          </v-col>
          <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
            <FormTextoArea
              v-model="sTemasTratados"
              :titulo="$store.state.jsIdioma.oEquivalencias.cmpTemasTratados"
              :editable="'1'"
              :sPlaceHolder="$store.state.jsIdioma.oEquivalencias.plhTemasTratados"
              :obligatorio="true"
            />
          </v-col>
          <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
            <FormTextoArea
              v-model="sDesarrollo"
              :titulo="$store.state.jsIdioma.oEquivalencias.cmpDesarrollo"
              :editable="'1'"
              :sPlaceHolder="$store.state.jsIdioma.oEquivalencias.plhDesarrollo"
              :obligatorio="true"
            />
          </v-col>
          <!-- CAMPO DE AÑADIR COMPROMISOS-->
          <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida mt-2">
            <span class="titleslight--text"> {{$store.state.jsIdioma.oEquivalencias.stlCompromisos}}</span>
            <v-col sm="12" cols="12" class=" pa-2 ma-0 under-sec-nomargin d-flex align-center justify-end " >
              <p color="primary" class="titleslight--text font-weight-medium pa-0 ma-0" >
                {{$store.state.jsIdioma.oEquivalencias.btnAñadirCompromisos}}
              </p>
              <v-btn
                color="primary"
                elevation="2"
                fab
                small
                @click="bMostrarCompromisos = true"
                class="ml-3"
              >
                <v-icon size="35">mdi-plus</v-icon>
              </v-btn>
            </v-col>
            <v-row>
              <v-col cols="12" sm="6" class="pa-0 ma-0 ColumnaResumida" v-for="(oRow, nKey) in aCompromisos" :key="nKey" >
                <v-card class="border-card px-2 ma-2">
                  <v-card-text class="text-h6 py-1 px-0 titlesdark--text d-flex">
                    {{$store.state.jsIdioma.oEquivalencias.cmpDescripcion}}

                    <v-btn
                      class="ml-auto"
                      icon
                      color="primary"
                      @click="onEliminarCompromiso(nKey)"
                    >
                      <v-icon>fa-solid fa-trash</v-icon>
                    </v-btn>
                  </v-card-text>
                  <v-card-text class="py-1 px-0 titlesdark--text">
                    {{ oRow.sDescripcion }}
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="d-flex align-end flex-column">
                    <v-btn
                      depressed
                      light
                      outlined
                      small
                      color="buttondark"
                      @click="onCargarDetalleCompromiso(oRow)"
                    >
                      {{$store.state.jsIdioma.oEquivalencias.btnVerMas}} >
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="pa-0 ma-0 ColumnaResumida">
                <modal-mensaje-general
                  v-model="oModalMensajeInput.bModalMensaje"
                  :sMensaje="oModalMensajeInput.sMensaje"
                  :nTipo="oModalMensajeInput.nTipo"
                  :sNombreBotonConfirmar="oModalMensajeInput.sNombreBotonConfirmar"
                  @respuesta="onRespuestaModal"
                />
              </v-col>
            </v-row>
          </v-col>
          <!-- CAMPO DE AÑADIR  ASISTENTES-->
          <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida mt-2">
            <span class="titleslight--text"> {{$store.state.jsIdioma.oEquivalencias.stlAsistentes}}*</span>
            <v-col sm="12" cols="12" class=" pa-2 ma-0 under-sec-nomargin d-flex align-center justify-end " >
              <p color="primary" class="titleslight--text font-weight-medium pa-0 ma-0" >
                {{$store.state.jsIdioma.oEquivalencias.btnAñadirAsistentes}}
              </p>
              <v-btn color="primary" elevation="2" fab small @click="bMostrarAsistentes = true" class="ml-3" >
                <v-icon size="35">mdi-plus</v-icon>
              </v-btn>
            </v-col>
            <v-row>
              <v-col sm="6" cols="12" class="pa-0 ma-0 ColumnaResumida" v-for="(oRow, nKey) in aAsistentes" :key="`_${nKey}`" >
                <v-card class="border-card px-2 my-1 mx-1">
                  <v-card-text class="ma-0 pa-1">
                    <v-row class="ma-0 pa-0">
                      <v-col sm="12" cols="12" class="pa-0 ma-0 ColumnaResumida titlesdark--text d-flex" >
                        <span class="text-medium">{{$store.state.jsIdioma.oEquivalencias.cmpNombreAsistente}}:</span>
                        <span class="ml-2">{{ oRow.sNombreAsistente }}</span>
                         <v-btn
                          class="ml-auto"
                          icon
                          color="primary"
                          @click="onEliminarAsistente(nKey)"
                        >
                          <v-icon>fa-solid fa-trash</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <!-- CAMPO DE ADJUNTAR ARCHIVOS-->
          <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida mt-2 adjuntar" >
            <span class="titleslight--text"> {{$store.state.jsIdioma.oEquivalencias.lblAnexos}} </span>
            <DragUpdateFile @files="f_anexos" :NoAnexos="10"></DragUpdateFile>
          </v-col>
          <!--  -->
          <v-col sm="12" cols="12" class="my-5 mx-0 ColumnaResumida">
            <FormCheckBox
              v-model="bCopiaCliente"
              :titulo="$store.state.jsIdioma.oEquivalencias.cmpCopiaProyecto"
              :editable="'1'"
            />
          </v-col>
          <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
            <FormTexto
              v-model="sCorreos"
              :titulo="$store.state.jsIdioma.oEquivalencias.cmpCorreo"
              :editable="'1'"
              :sTooltip="$store.state.jsIdioma.oEquivalencias.lblCorreoEj"
              :sPlaceHolder="$store.state.jsIdioma.oEquivalencias.plhCorreo"
              :obligatorio="true"
            />
          </v-col>
          <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
            <v-row justify="center" align="center" class="pa-4">
              <v-btn class="no-uppercase d-flex mx-2" large depressed dark color="btndest" @click="CloseDialog" outlined rounded>
                {{ $store.state.jsIdioma.oEquivalencias.btnCancelar }}
              </v-btn>
              <v-btn class="no-uppercase d-flex mx-2" large depressed dark color="primary" @click="Save" rounded :loading="bLoading">
                {{ $store.state.jsIdioma.oEquivalencias.btnGuardar }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="bMostrarCompromisos" persistent max-width="750px" :key="`_${nKeyModalCompromisos}`" >
      <v-card min-height="400px">
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer />
          <span class="mdlHeadForms">{{$store.state.jsIdioma.oEquivalencias.stlCompromisos}}</span>
          <v-spacer />
          <v-btn
            color="btncolor-dark"
            @click="onResetVistaCompromisos"
            icon
            small
            dark
            outlined
          >
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="py-3">
          <v-row>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <FormTexto
                v-model="oCompromisos.sDescripcion"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpDescripcion"
                :sPlaceHolder="$store.state.jsIdioma.oEquivalencias.plhGenericoCampoTexto.replace('XXXX',$store.state.jsIdioma.oEquivalencias.cmpDescripcion)"
                :editable="'1'"
                :obligatorio="true"
              />
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <FormTexto
                v-model="oCompromisos.sResponsable"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpResponsable"
                :sPlaceHolder="$store.state.jsIdioma.oEquivalencias.plhGenericoCampoTexto.replace('XXXX',$store.state.jsIdioma.oEquivalencias.cmpResponsable)"
                :editable="'1'"
                :obligatorio="true"
              />
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <FormDate
                v-model="oCompromisos.sFechaCompromiso"
                :campo="'FechaCompromiso'"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpFechaCompromiso"
                :sPlaceHolder="''"
                :editable="'1'"
                :obligatorio="true"
                :bDesdeHoy="true"
              >
              </FormDate>
            </v-col>
            <v-col
              sm="12"
              cols="12"
              class="pa-2 ma-0 ColumnaResumida under-sec-nomargin text-center"
            >
              <FormSiNo
                v-model="oCompromisos.bPqr"
                :campo="'bPqr'"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpConvertirPqr"
                :editable="'1'"
                :obligatorio="true"
              >
              </FormSiNo>
            </v-col>
            <v-col
              v-if="oCompromisos.bPqr == '1'"
              sm="12"
              cols="12"
              class="py-3 px-0 ColumnaResumida"
            >
              <v-row>
                <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
                  <FormSelect
                    v-model="oCompromisos.nDepartamento"
                    :titulo="$store.state.jsIdioma.oEquivalencias.cmpDepartamento"
                    :inner="'Departamentos,'"
                    :campo="'NombreDepartamento'"
                    :obligatorio="true"
                    :editable="'1'"
                  ></FormSelect>
                </v-col>
                <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
                  <FormSelectFiltro
                    v-model="oCompromisos.nDependencia"
                    :titulo="$store.state.jsIdioma.oEquivalencias.cmpDependencia"
                    :inner="'Dependencias,'"
                    :campo="'Nombre_Dependencia'"
                    :obligatorio="true"
                    :campoFiltro="'idDepartamento'"
                    :valorFiltro="oCompromisos.nDepartamento"
                    :editable="'1'"
                  ></FormSelectFiltro>
                </v-col>
                <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
                  <FormSelect
                    v-model="oCompromisos.nTipoRequerimiento"
                    :titulo="$store.state.jsIdioma.oEquivalencias.cmpTipoRequerimiento"
                    :inner="'PQR_Tipos_requerimiento,'"
                    :campo="'Detalle'"
                    :obligatorio="true"
                    :editable="'1'"
                  ></FormSelect>
                </v-col>
                <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
                  <FormSelect
                    v-model="oCompromisos.nPrioridad"
                    :titulo="$store.state.jsIdioma.oEquivalencias.cmpPrioridad"
                    :inner="'PQR_Prioridad_requerimiento,'"
                    :campo="'Prioridad'"
                    :obligatorio="true"
                    :editable="'1'"
                  ></FormSelect>
                </v-col>
              </v-row>
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida mt-2">
              <v-row justify="center" align="center">
                <v-btn
                  class="btn-rounded d-flex mx-2"
                  depressed
                  light
                  outlined
                  color="buttondark"
                  @click="onAgregarCompromiso"
                  >{{$store.state.jsIdioma.oEquivalencias.btnAñadir}}</v-btn
                >
                <v-btn
                  class="btn-rounded d-flex mx-2"
                  depressed
                  light
                  outlined
                  color="buttondark"
                  @click="onResetVistaCompromisos"
                  >{{$store.state.jsIdioma.oEquivalencias.btnCancelar}}</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bMostrarCompromisosLectura" persistent max-width="650px">
      <v-card class="pb-3">
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer />
          <span class="mdlHeadForms">{{$store.state.jsIdioma.oEquivalencias.stlVerItem.replace('XXXX', $store.state.jsIdioma.oEquivalencias.ttlCompromisos)}}</span>
          <v-spacer />
          <v-btn
            color="btncolor-dark"
            @click="onResetVistaCompromisos"
            icon
            small
            dark
            outlined
          >
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="pt-2">
          <v-row>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <CampoLectura
                v-model="oCompromisos.sDescripcion"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpDescripcion"
                :obligatorio="true"
              />
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <CampoLectura
                v-model="oCompromisos.sResponsable"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpResponsable"
                :obligatorio="true"
              />
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <CampoLectura
                v-model="oCompromisos.sFechaCompromiso"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpFechaCompromiso"
                :obligatorio="true"
              />
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <CampoLectura
                v-model="oCompromisos.bPqr"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpConvertirPqr"
                :obligatorio="true"
                :modo="2"
                :aItems="[
                  {
                    id: 0,
                    texto: $store.state.jsIdioma.oEquivalencias.lblNo,
                  },
                  {
                    id: 1,
                    texto: $store.state.jsIdioma.oEquivalencias.lblSi,
                  },
                ]"
              />
            </v-col>
            <v-divider></v-divider>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida d-flex justify-center" >
              <v-btn
                class="btn-rounded d-flex mx-2 margin-auto"
                depressed
                light
                outlined
                color="buttondark"
                @click="onResetVistaCompromisos"
              >
                Volver
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bMostrarAsistentes" persistent max-width="400px" :key="nKeyModalAsistentes" >
      <v-card>
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer />
          <span class="mdlHeadForms">{{$store.state.jsIdioma.oEquivalencias.stlVerItem.replace('XXXX', $store.state.jsIdioma.oEquivalencias.stlAsistentes)}}</span>
          <v-spacer />
          <v-btn color="btncolor-dark" @click="onResetVistaAsistentes" icon small dark outlined >
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="mt-2">
          <v-row>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <FormTexto
                v-model="oAsistentes.sNombreAsistente"
                :titulo="$store.state.jsIdioma.oEquivalencias.cmpNombreAsistente"
                :editable="'1'"
                :obligatorio="true"
              />
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida mb-3 mt-3">
              <v-row justify="center" align="center">
                <v-btn class="d-flex mx-2" depressed light outlined color="primary" @click="onResetVistaAsistentes" rounded>
                  {{ $store.state.jsIdioma.oEquivalencias.btnCancelar }}
                </v-btn>
                <v-btn class="d-flex mx-2" depressed light color="primary" @click="onAgregarAsistente" rounded>
                  <v-icon>mdi-plus</v-icon>
                  {{ $store.state.jsIdioma.oEquivalencias.btnAñadir }}
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <ErrorView v-model="bMostrarErrores" :aErrores="aErrores"></ErrorView>
    <ModalMensaje
      v-model="oModalMensaje.bModalMensaje"
      :sMensaje="oModalMensaje.sMensaje"
      :nTipo="oModalMensaje.nTipo"
    />
  </v-layout>
</template>

<script>

import mxFunciones from '@/mixins/funciones.js'
import HoraFecha from '@/Utlidades/Hora_Fecha.js'
import FormSelect from '@/components/Form/Componentes/FormSelect.vue'
import CampoLectura from '@/components/CampoLectura.vue'
import ModalMensaje from '@/components/ModalMensaje.vue'
import FormSelectFiltro from '@/components/Form/Componentes/FormSelectFiltro.vue'
import FormSiNo from '@/components/Form/Componentes/FormSiNo.vue'
import FormDate from '@/components/Form/Componentes/FormDate.vue'
import FormCheckBox from '@/components/Form/Componentes/FormCheckBox.vue'
import FormTexto from '@/components/Form/Componentes/FormTexto.vue'
import FormTextoArea from '@/components/Form/Componentes/FormTextArea.vue'
import axiosServices from '@/services/axiosServices.js'
import DragUpdateFile from '@/components/DragUpdateFile.vue'
import GPSLocation from '@/Utlidades/GPSlocation.js'
import ErrorView from '@/components/ErrorView.vue'


export default {
  name: "NuevaActaReunionPqr",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormCheckBox,
    FormSelect,
    FormSelectFiltro,
    FormTexto,
    DragUpdateFile,
    ErrorView,
    FormSiNo,
    FormDate,
    CampoLectura,
    ModalMensaje,
    FormTextoArea,
  },
  data() {
    return {
      nKeyModalCompromisos: 0,
      nKeyModalAsistentes: 0,
      bMostrarCompromisos: false,
      bMostrarAsistentes: false,
      bMostrarCompromisosLectura: false,
      oModalMensaje: {
        bModalMensaje: false,
        sMensaje: "",
        nTipo: 1,
      },
      oModalMensajeInput: {
        bModalMensaje: false,
        sMensaje: "",
        nTipo: 1,
        sNombreBotonConfirmar: 'Eliminar'
      },
      oCompromisos: {
        sDescripcion: "",
        sResponsable: "",
        sFechaCompromiso: "",
        bPqr: "",
        nDepartamento: "",
        nDependencia: "",
        nTipoRequerimiento: "",
        nPrioridad: "",
      },
      oAsistentes: {
        sNombreAsistente: "",
      },
      aAsistenes: [],
      nCliente: "",
      nProducto: "",
      sTemasTratados: "",
      sDesarrollo: "",
      sCorreos: "",
      sObservaciones: "",
      aCompromisos: [],
      aAsistentes: [],
      bCopiaCliente: false,
      KeyRefresh: 0, // empleo esta variale para refrescar los componentes
      bMostrarErrores: false,
      aAnexos: [],
      aErrores: [],
      sTipoEliminar: '',
      nKeyActual: -1, // variable usada para saber la posicion actual de cualquier array dspues d eusarse queda en -1
      bLoading: false, // Se añade para indicar que está cargando el boton de guardar
    };
  },
  mixins: [mxFunciones],
  mounted() {},
  methods: {
    CloseDialog() {
      this.$emit("input", false);
    },
    refrescar() {
      this.KeyRefresh++;
    },
    async Save() {
      try {
        this.validarCampos();

        // Valido que bMostrarErrores siga en falso
        if (this.bMostrarErrores) return;

        const oLocation = await GPSLocation.getCurrentPosition();
        const aLocalAsistentes = [];
        this.aAsistentes.forEach((item) => {
          aLocalAsistentes.push({
            NombreAsistente: item.sNombreAsistente,
            NombreFirma: "sinfoto.jpg",
          });
        });
        const aLocalCompromisos = [];
        this.aCompromisos.forEach((item) => {
          aLocalCompromisos.push({
            Descripcion: item.sDescripcion,
            Responsable: item.sResponsable,
            Fecha: item.sFechaCompromiso,
            isPQR: item.bPqr == "0" ? false : true,
            idDepartamento: item.nDepartamento == "" ? 0 : item.nDepartamento,
            idDependencia: item.nDependencia == "" ? 0 : item.nDependencia,
            idTipo: item.nTipoRequerimiento == "" ? 0 : item.nTipoRequerimiento,
            idPrioridad: item.nPrioridad == "" ? 0 : item.nPrioridad,
          });
        });
        const aLocalCorreos = [];
        this.sCorreos.split(";").forEach((item) => {
          aLocalCorreos.push({
            Email: item,
          });
        });
        const oBody = {
          app: "NuevaActaReunionPqr-web",
          accion: "ActaReunion_Secancol",
          proyecto: this.nCliente,
          nProducto: this.nProducto,
          tema: this.sTemasTratados,
          desarrollo: this.sDesarrollo,
          asistente: aLocalAsistentes,
          desarrolloReunion: aLocalCompromisos,
          fotos: this.FormatAnexos(),
          copyEmail: this.bCopiaCliente ? "1" : "0",
          emails: aLocalCorreos,
          fecha: `${this.HoraRegistro}`,
          latitud: oLocation.coords.latitude,
          longitud: oLocation.coords.longitude,
        };
        this.bLoading = true;
        const respuesta = await axiosServices.postConfiguration( "/cop/acta-reunion-pqr", oBody, true );
        //console.log('ActaReunion respuesta', respuesta)
        if (respuesta.nStatusCode == 200 || respuesta.nStatusCode == 220) {
          this.onSubirAnexos(this.aAnexos);
          this.$store.dispatch("notificaciones/SetMensaje", respuesta.sMessage);
          this.$store.dispatch("notificaciones/SetColor", "success");
          this.$store.dispatch("notificaciones/ShowNotificacion", true);
          this.CloseDialog();
        } else {
          this.$store.dispatch("notificaciones/SetMensaje", respuesta.sMessage);
          this.$store.dispatch("notificaciones/SetColor", "error");
          this.$store.dispatch("notificaciones/ShowNotificacion", true);
        }
        this.bLoading = false;

      } catch (error) {
        this.$store.dispatch(
          "notificaciones/SetMensaje",
          "ERROR: GPS inactivo o No se tienen permiso para obtener la Ubicabion. Valide y refresque la Pantalla"
        );
        this.$store.dispatch("notificaciones/SetColor", "error");
        this.$store.dispatch("notificaciones/ShowNotificacion", true);
        this.bErrorPermisos = false;
        this.bLoading = false;
      }
    },
    f_anexos(files) {
      this.aAnexos = files;
    },
    FormatAnexos() {
      let aGaleria = [];
      // recorro los Anexos para sacar todos los nombres de las anexos que tenga y dejarlos como [ {Foto : "NombreArchico"}]
      this.aAnexos.forEach(Anexos => {
        if(Anexos) {
          aGaleria.push({ 
            Foto : Anexos.name,
            TipoAnexo: Anexos.type.includes("image") ? "1" : "2",
          })
        }
      });

      return aGaleria;
    },
    validarCampos() {
      this.aErrores = [];
      this.bMostrarErrores = false;

      if (this.nCliente === "" || this.nCliente === null)
        this.aErrores.push("Debe seleccionar un cliente");
      if (this.nProducto === "" || this.nProducto === null)
        this.aErrores.push("Debe seleccionar un producto");
      if (this.sTemasTratados === "" || this.sTemasTratados === null)
        this.aErrores.push("Debe diligenciar los temas tratados");
      if (this.sDesarrollo === "" || this.sDesarrollo === null)
        this.aErrores.push("Debe indicar desarrollo de la reunión");
      if (this.sTemasTratados.length > 3000)
        this.aErrores.push(
          "Ha excedido máximo de caracteres permitidos en los temas tratados"
        );
      if (this.sDesarrollo.length > 3000)
        this.aErrores.push(
          "Ha excedido máximo de caracteres permitidos en el desarrollo de la reunión"
        );

      if (this.seContacto === "1") {
        if (this.Funcionario === "")
          this.aErrores.push("Debe indicar un funcionario");
        if (this.Cedula === "")
          this.aErrores.push("Debe indicar la cedula del funcinario");
        if (this.Motivo === "") this.aErrores.push("Debe indicar un motivo");
        if (this.Medio === "") this.aErrores.push("Debe indicar un Medio");
      }
      if (this.sCorreos === "" || this.sCorreos === null) {
        this.aErrores.push("Debe diligenciar los correos");
      } else {
        this.sCorreos.split(";").forEach((item) => {
          const emailRegex =
            /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
          if (!emailRegex.test(item)) {
            this.aErrores.push("Correo " + item + " inválido");
          }
        });
      }

      this.bMostrarErrores = this.aErrores.length > 0;
    },
    validarCamposCompromisos() {
      this.aErrores = [];
      this.bMostrarErrores = false;

      if (
        this.oCompromisos.sDescripcion === "" ||
        this.oCompromisos.sDescripcion === null
      )
        this.aErrores.push("Debe diligenciar la descripción");
      if (
        this.oCompromisos.sResponsable === "" ||
        this.oCompromisos.sResponsable === null
      )
        this.aErrores.push("Debe diligenciar el responsable");
      if (
        this.oCompromisos.sFechaCompromiso === "" ||
        this.oCompromisos.sFechaCompromiso === null
      )
        this.aErrores.push("Debe seleccionar una fecha de compromiso");
      if (this.oCompromisos.bPqr === "" || this.oCompromisos.bPqr === null)
        this.aErrores.push("Debe indicar si se creará o no un PQR");

      if (this.oCompromisos.bPqr === "1") {
        if (
          this.oCompromisos.nDepartamento === "" ||
          this.oCompromisos.nDepartamento === null
        )
          this.aErrores.push("Debe seleccionar un departamento");
        if (
          this.oCompromisos.nDependencia === "" ||
          this.oCompromisos.nDependencia === null
        )
          this.aErrores.push("Debe seleccionar una dependencia");
        if (
          this.oCompromisos.nTipoRequerimiento === "" ||
          this.oCompromisos.nTipoRequerimiento === null
        )
          this.aErrores.push("Debe seleccionar un tipo de requerimiento");
        if (
          this.oCompromisos.nPrioridad === "" ||
          this.oCompromisos.nPrioridad === null
        )
          this.aErrores.push("Debe seleccionar una prioridad");
      }

      this.bMostrarErrores = this.aErrores.length > 0;
    },

    validarCamposAsistentes() {
      this.aErrores = [];
      this.bMostrarErrores = false;

      if (
        this.oAsistentes.sNombreAsistente === "" ||
        this.oAsistentes.sNombreAsistente === null
      )
        this.aErrores.push("Debe diligenciar elnombre del asistente");

      this.bMostrarErrores = this.aErrores.length > 0;
    },
    onResetVistaCompromisos() {
      this.bMostrarCompromisos = false;
      this.bMostrarCompromisosLectura = false;
      this.oCompromisos = {
        sDescripcion: "",
        sResponsable: "",
        sFechaCompromiso: "",
        bPqr: "",
        nDepartamento: "",
        nDependencia: "",
        nTipoRequerimiento: "",
        nPrioridad: "",
      };
    },
    onResetVistaAsistentes() {
      this.bMostrarAsistentes = false;
      this.oAsistentes = {
        sNombreAsistente: "",
      };
    },
    onAgregarCompromiso() {
      this.validarCamposCompromisos();

      // Valido que bMostrarErrores siga en falso
      if (this.bMostrarErrores) return;

      this.aCompromisos.push(this.oCompromisos);
      this.oModalMensaje = {
        bModalMensaje: false,
        sMensaje: "Compromiso creado",
        nTipo: 1,
      };
      this.onResetVistaCompromisos();
    },
    onAgregarAsistente() {
      this.validarCamposAsistentes();

      // Valido que bMostrarErrores siga en falso
      if (this.bMostrarErrores) return;

      this.aAsistentes.push(this.oAsistentes);
      this.oModalMensaje = {
        bModalMensaje: false,
        sMensaje: "Asistente creado",
        nTipo: 1,
      };
      this.onResetVistaAsistentes();
    },
    onCargarDetalleCompromiso(oRow) {
      this.oCompromisos = oRow;
      this.bMostrarCompromisosLectura = true;
    },
    onEliminarCompromiso(nKey) {
      this.nKeyActual = nKey
      this.oModalMensajeInput.bModalMensaje = true
      this.oModalMensajeInput.sMensaje = '¿Estás seguro de eliminar el compromiso?'
      this.sTipoEliminar = 'Compromiso'
    },
    onEliminarAsistente(nKey) {
      this.nKeyActual = nKey
      this.oModalMensajeInput.bModalMensaje = true
      this.oModalMensajeInput.sMensaje = '¿Estás seguro de eliminar el asistente?'
      this.sTipoEliminar = 'Asistente'
    },
    onRespuestaModal (bRespuesta) {
      this.oModalMensajeInput.bModalMensaje = false
      if (bRespuesta) {
        if( this.sTipoEliminar==='Asistente') {
          this.aAsistentes.splice(this.nKeyActual, 1)
        } else if ( this.sTipoEliminar==='Compromiso') {
          this.aCompromisos.splice(this.nKeyActual, 1)
        }
        this.nKeyActual = -1
        this.sTipoEliminar = ''
      }
    }
  },
  computed: {
    HoraRegistro() {
      this.refrescar();
      if (this.value) {
        return HoraFecha.getNow();
      }

      return "";
    },
  },
  watch: {
    bMostrarCompromisos(bNuevoValor) {
      if (bNuevoValor) this.nKeyModalCompromisos++;
    },
    bMostrarAsistentes(bNuevoValor) {
      if (bNuevoValor) this.nKeyModalAsistentes++;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
